export const title = `
  text-ll-font-size-h3 font-bold leading-8 mb-2
`;
